import React from 'react'
import thanks_letter_1 from './static/img/thanks_letter_1.jpg'
import thanks_letter_2 from './static/img/thanks_letter_2.jpg'
import thanks_letter_3 from './static/img/thanks_letter_3.jpg'

function ThanksLettersSection() {
  return (
    <div className="thanks_letters_section">
            <h2 className="thanks_letters_title">Feedback from our clients</h2>
        <div className="thanks_letters_inner_wrapper">
            <img src={thanks_letter_1} alt="" />
            <img src={thanks_letter_2} alt="" />
            <img src={thanks_letter_3} alt="" />
        </div>
    </div>
  )
}

export default ThanksLettersSection